import React from 'react';
import {
  Filter as FilterAdmin,
  ReferenceInput,
  SelectInput,
  AutocompleteInput,
  BooleanInput,
  TextInput,
} from 'react-admin';

import {
  CnpjInput,
  CpfInput,
  PeriodoInput,
  PrecoInput,
} from '../../Components/InputsReactAdmin';
import { STATUS_ATIVO } from '../../utils/constants';
import { choicesStatusEntrega } from './choices';

const Filter = (props) => (
  <FilterAdmin {...props}>
    <PeriodoInput
      source="periodo"
      label="Período"
      defaultValue={{
        start: new Date(),
        end: new Date(),
      }}
    />
    <ReferenceInput
      fullWidth
      label="Cliente"
      source="cliente_id"
      reference="clientes"
      sort={{ field: 'nome', order: 'ASC' }}
      filterToQuery={(searchText) => ({ nome: `${searchText}` })}
      filter={{ status: STATUS_ATIVO }}
    >
      <AutocompleteInput optionText="nome" />
    </ReferenceInput>
    <TextInput source="razao_social" label="Razão Social" />
    <TextInput source="nome_fantasia" label="Nome Fantasia" />
    <CnpjInput source="cnpj" label="CNPJ" />
    <CpfInput source="cpf" label="CPF" />
    <TextInput source="numero" label="Número da venda" />
    <SelectInput
      label="Entrega Concluída"
      source="status_entrega"
      choices={choicesStatusEntrega}
      allowEmpty={false}
    />
    <BooleanInput label="Venda em partes" source="is_em_partes" />
    <PrecoInput
      source="valor"
      label="Valor da venda"
      fixedDecimalScale={false}
    />
    <PrecoInput
      source="valor_final"
      label="Valor Final da venda"
      fixedDecimalScale={false}
    />
    <PrecoInput
      source="valorDinheiro"
      label="Valor Parcela Dinheiro"
      fixedDecimalScale={false}
    />
    <PrecoInput
      source="valorPix"
      label="Valor Parcela Pix"
      fixedDecimalScale={false}
    />
    <PrecoInput
      source="valorDebito"
      label="Valor Parcela Débito"
      fixedDecimalScale={false}
    />
    <PrecoInput
      source="valorVonchuer"
      label="Valor Parcela Voucher"
      fixedDecimalScale={false}
    />
    <PrecoInput
      source="valorDescontoDevolucao"
      label="Valor Parcela Devolução"
      fixedDecimalScale={false}
    />
    <PrecoInput
      source="valorCredito"
      label="Valor Parcela Crédito"
      fixedDecimalScale={false}
    />
    <PrecoInput
      source="valorBoleto"
      label="Valor Parcela Boleto"
      fixedDecimalScale={false}
    />
  </FilterAdmin>
);

export default Filter;

// mudar qui
